import { HISTORY_MODE } from '../../constants/index';
import { eq } from 'ember-truth-helpers';
import { on } from '@ember/modifier';
import { service } from '@ember/service';
import { t } from 'ember-intl';
import BaseRoute from './base-route.gjs';
import Component from '@glimmer/component';
import FlexColumn from 'ember-simplepractice/components/spds/layout/flex/column';
import GhostButton from 'ember-simplepractice/components/spds/action/button/ghost';
import PrimaryButton from 'ember-simplepractice/components/spds/action/button/primary';
import RadioButton from 'ember-simplepractice/components/spds/input/radio-button';
import styles from './add-members-history.module.scss';
import svgJar from 'ember-svg-jar/helpers/svg-jar';

export default class MessagingRoutesAddMembersHistory extends Component {
  @service messagingNavigation;

  historyModes = HISTORY_MODE;

  historyOptions = [
    {
      id: 'add-members-history-full',
      value: this.historyModes.FULL,
      labelKey: 'emc.add_team_members.history.from_beginning',
      hintKey: 'emc.add_team_members.history.from_beginning_hint',
    },
    {
      id: 'add-members-history-new-only',
      value: this.historyModes.NEW_ONLY,
      labelKey: 'emc.add_team_members.history.from_join',
      hintKey: 'emc.add_team_members.history.from_join_hint',
    },
  ];

  get routeHandler() {
    return this.args.handler;
  }

  goBack = async () => {
    await this.messagingNavigation.leaveChildRoute();
  };

  continue = () => {
    this.routeHandler.submit.perform();
  };

  <template>
    <BaseRoute
      class="{{styles.component}} add-members-history-page"
      data-test-add-members-history-route
    >
      <:header>
        <GhostButton
          @fitContent={{true}}
          @iconOnly={{true}}
          {{on "click" this.goBack}}
          class="back-button"
          data-test-add-members-history-back-button
        >
          {{svgJar "messaging-chevron-left"}}
        </GhostButton>
        <span class="title" data-test-add-members-history-title>
          {{t "emc.add_team_members.title"}}
        </span>
      </:header>
      <:default>
        <FlexColumn @gap="1.5rem" class="history-content">
          <FlexColumn @gap="4px">
            <h2 class="history-title" id="history-title" data-test-history-title>
              {{t "emc.add_team_members.history.title"}}
            </h2>
            <p class="history-description" data-test-history-description>
              {{t "emc.add_team_members.history.description"}}
            </p>
          </FlexColumn>

          <FlexColumn
            @gap="1rem"
            class="history-options"
            role="radiogroup"
            aria-labelledby="history-title"
          >
            {{#each this.historyOptions as |option|}}
              <RadioButton
                @id={{option.id}}
                @name="add-members-history"
                @groupName="add-members-history"
                @value={{option.value}}
                @checked={{eq this.routeHandler.historyMode option.value}}
                @onClick={{this.routeHandler.selectHistoryMode}}
                data-test-history-mode={{option.value}}
              >
                <:label>
                  <FlexColumn class="radio-copy">
                    <span class="radio-label">
                      {{t option.labelKey}}
                    </span>
                    <span class="radio-hint">
                      {{t option.hintKey}}
                    </span>
                  </FlexColumn>
                </:label>
              </RadioButton>
            {{/each}}
          </FlexColumn>
        </FlexColumn>
      </:default>
      <:footer>
        <PrimaryButton
          @disabled={{this.routeHandler.isContinueDisabled}}
          {{on "click" this.continue}}
          data-test-add-members-history-continue
        >
          {{t "emc.add_team_members.history.continue"}}
        </PrimaryButton>
      </:footer>
    </BaseRoute>
  </template>
}
